import React from 'react';
import VoiceToTextTextarea from '@components/VoiceToTextTextarea';
import getVoiceToTextBlockedMessages from './VoiceTranscribing/utils';
import { AboutMeTypes } from '../StepThreeTypes';

interface MyWellnessProps {
  aboutMe: AboutMeTypes;
  setAboutMe: (aboutMe: AboutMeTypes) => void;
}

const MyWellness: React.FC<MyWellnessProps> = ({ aboutMe, setAboutMe }) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <h1 className="govuk-label-wrapper">
        <label className="govuk-label govuk-label--l" htmlFor="my-wellness">
          My wellness
        </label>
      </h1>
      <div className="govuk-body">
        A description covering what you are able to do, how you engage with
        others and how you feel on a typical day through to on a day when you
        are unwell or really unwell.
      </div>

      <div className="govuk-body">
        <ul className="govuk-list govuk-list--bullet">
          <li>
            Include any causes that might result in you becoming unwell and
            strategies for avoiding or addressing the causes. For example, not
            drinking enough water could cause constipation.
          </li>
          <li>Include any signs that indicate you might be becoming unwell.</li>
          <li>
            On a bad day describe what is different about what you are able to
            do, how you engage with others and how you feel.
          </li>
          <li>
            Include how your everyday life is affected by any medical conditions
            e.g. dementia and any symptoms e.g. itchiness, cough, pain and how
            you manage those conditions.
          </li>
          <li>
            Include past health issues or experiences that need to be
            considered.
          </li>
          <li>Include your wellbeing and lifestyle goals and aspirations.</li>
        </ul>
      </div>
      <details className="govuk-details">
        <summary className="govuk-details__summary">
          <span className="govuk-details__summary-text">Prompt questions</span>
        </summary>
        <div className="govuk-details__text">
          <div className="govuk-body">
            1. What shows the good things in your life and who you are as a
            person? Think about photos, videos, letters from people you value,
            Facebook pages, X (formally Twitter) or Instagram accounts.
          </div>
          <div className="govuk-body">
            2. What are you able to do and how do you feel on a typical day?
          </div>
          <div className="govuk-body">
            3. How do any conditions or symptoms you live with affect you and
            how do you manage them?
          </div>
          <div className="govuk-body">
            4. Do you have any long-term pain, if so, how do you manage it?
          </div>
          <div className="govuk-body">
            5. Do you have past events or health issues that affect you, if so,
            how do you manage them?
          </div>
          <div className="govuk-body">
            6. What triggers or vulnerabilities can cause you to become unwell,
            how do you avoid or address them?
          </div>
          <div className="govuk-body">
            7. What might indicate that you are becoming unwell, how do you
            manage it?
          </div>
          <div className="govuk-body">
            8. What are you able to do and how do you feel on a bad day, how do
            you want to be supported?
          </div>
          <div className="govuk-body">
            9. What helps and hinders you to be well?
          </div>
        </div>
      </details>

      <VoiceToTextTextarea
        id="my-wellness"
        name="myWellness"
        value={aboutMe.myWellness || ''}
        rows={5}
        autoComplete="my-wellness"
        placeholder="Type here or use voice to text..."
        recordBlockedErrors={getVoiceToTextBlockedMessages(aboutMe)}
        onChange={value => setAboutMe({ ...aboutMe, myWellness: value })}
      />
    </div>
  );
};

export default MyWellness;
